<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-2">
                <h2>Contactez-nous pour<br>un diagnostic gratuit</h2>
                <p v-if="step !== 3">Nous vous accompagnons du diagnostic au suivi de contrôle après l’installation. <br>Faites confiance aux professionnels de l’humidité.</p>
            </div>
            <fieldset class="tw-px-3 tw-pb-6 lg:tw-px-10 lg:tw-pb-12">
                <div class="step" v-if="step === 1">
                    <div class="question">Quel est le type de bien<br>concerné ?</div>
                    <validation-provider class="tw-w-full tw-w-block" name="type" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-type" :class="classes">
                            <select id="input-type" placeholder=" " v-model="type">
                                <option selected disabled>Type de bien</option>
                                <option value="Appartement en rez-de-chaussée">Appartement en rez-de-chaussée</option>
                                <option value="Rez-de-jardin">Rez-de-jardin</option>
                                <option value="Maison">Maison</option>
                                <option value="Cave">Cave</option>
                                <option value="Immeuble">Immeuble</option>
                                <option value="Biens communaux">Biens communaux</option>
                            </select>
                            <label :class="{ 'select-placeholder' : !type }">
                                Type de bien
                            </label>
                        </div>
                    </validation-provider>
                    <button class="btn-cta" @click.prevent="step++;" :class="{ 'disabled' : !type }">suivant</button>
                </div>
                <div class="step" v-if="step === 2">
                    <div class="question">Quelle est son année<br>de construction ?</div>
                    <validation-provider class="tw-w-full tw-w-block" name="year" rules="required" v-slot="{ classes }" key="yearField">
                        <div class="input-group input-group-year" :class="classes">
                            <select id="input-year" placeholder=" " v-model="year">
                                <option selected disabled>Année de construction</option>
                                <option value="Avant 1945">Avant 1945</option>
                                <option value="Après 1945">Après 1945</option>
                            </select>
                            <label :class="{ 'select-placeholder' : !year }">
                                Année de construction
                            </label>
                        </div>
                    </validation-provider>
                    <button class="btn-cta" @click.prevent="step++;" :class="{ 'disabled' : !year }">suivant</button>
                </div>
                <div class="step" v-if="step === 3">
                    <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-2">
                        <validation-provider class="tw-w-full tw-w-block" name="lastName" rules="required|alpha_spaces" v-slot="{ classes }">
                            <div class="input-group input-group-name" :class="classes">
                                <input type="text"
                                    id="input-lastName"
                                    placeholder=" "
                                    v-model="lastName"
                                >
                                <label>
                                    Nom
                                </label>
                            </div>
                        </validation-provider>
                        <validation-provider class="tw-w-full tw-w-block" name="firstName" rules="required|alpha_spaces" v-slot="{ classes }">
                            <div class="input-group input-group-name" :class="classes">
                                <input type="text"
                                    id="input-firstName"
                                    placeholder=" "
                                    v-model="firstName"
                                >
                                <label>
                                    Prénom
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:fr" v-slot="{ classes }">
                        <div class="input-group input-group-phone" :class="classes">
                            <input type="tel"
                                id="input-phone"
                                placeholder=" "
                                v-model="phone"
                                v-mask="{mask: '9999999999', placeholder: ' '}"
                            >
                            <label>
                                Téléphone
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'invalide' }">
                        <div class="input-group input-group-email" :class="classes">
                            <input type="email"
                                id="input-email"
                                placeholder=" "
                                v-model.lazy="email"
                            >
                            <label>
                                E-mail {{ errors [0]}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="zip" rules="required|zip:fr" v-slot="{ classes }">
                        <div class="input-group input-group-zip" :class="classes">
                            <input type="tel"
                                id="input-zip"
                                placeholder=" "
                                v-model="zip"
                                v-mask="{mask: '99999', placeholder: ' '}"
                                @input="checkZips"
                            >
                            <label>
                                Code Postal
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                        <div class="mb-2">
                            <div class="form-check p-0">
                                <label class="form-check-label" :class="classes">
                                    <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                    <span class="checkmark"></span>
                                    <span class="tw-text-black">J’autorise {{ company }} à utiliser mes données pour me contacter conformément à sa <a href="#" @click.prevent="$store.state.modal.terms = true"><u>politique de confidentialité</u></a>.</span>
                                </label>
                            </div>
                        </div>
                    </validation-provider>
                    <div class="tw-text-center tw-mt-4">
                        <button
                            type="submit"
                            class="btn-cta"
                            id="submit"
                            :disabled="formLoading"
                        >
                            ENVOYER
                        </button>
                    </div>
                </div>
                <div class="steps tw-flex tw-mx-auto tw-items-center tw-justify-center tw-gap-3 tw-mt-6 lg:tw-mt-10">
                    <div :class="{ 'active' : step >= 1 }"></div>
                    <div :class="{ 'active' : step >= 2 }"></div>
                    <div :class="{ 'active' : step >= 3 }"></div>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            type: this.$route.query.type || '',
            year: this.$route.query.year || '',
            lastName: this.$route.query.lastName || '',
            firstName: this.$route.query.firstName || '',
            phone: this.$route.query.phone || '',
            email: this.$route.query.email || '',
            zip: this.$route.query.zip || '',

            step: 1,
            zipError: false,

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        checkZips() {
            var zipDepartment = this.zip.substring(0, 2);
            const refusedDepartments = ['75', '91', '92', '93', '94', '95', '77', '78', '51', '45', '41', '02', '37', '89', '10'];
            if(!refusedDepartments.some(z => zipDepartment.includes(z))) {
                this.zipError = true;
            } else {
                this.zipError = false;
            }
        },
        formSubmit() {
            this.formLoading = true;

            if(this.year == 'Après 1945' || this.zipError) {
                this.formLoading = false;
                this.$store.state.formError = true;
                return false;
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                type: this.type,
                year: this.year,
                lastName: this.lastName,
                firstName: this.firstName,
                phone: this.phone,
                email: this.email,
                zip: this.zip,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'déjà enregistré';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
